<template>
    <div>
        <h5 class="my-3">{{ $t('managerForm.settingAdvanced.choiceSettingBlock') }}</h5>
        <b-tabs
            v-model="activeBlockTab"
            content-class="mt-3 ml-3"
            active-nav-item-class="font-weight-bold acitve-block-custom-form"
            nav-class="nav-block-custom"
            pills
        >
            <b-tab v-for="(tbem, index) in blockTab" :key="index" class="border-0">
                <template v-slot:title>
                    <span class="">{{ tbem.value }}</span>
                </template>
                <b-card-text>
                    <!-- 送信設定 -->
                    <div class="form-group row">
                        <label class="col-sm-1 text-nowrap" style="min-width: 190px">{{ $t('managerForm.settingAdvanced.settingSending') }}</label>
                        <div class="col-sm-9">
                            <div class="d-flex flex-wrap" style="gap: 12px">
                                <div v-for="(item, idx) in OPTION_SENDING_CONDITIONS" :key="idx">
                                    <InputRadio
                                        class="mr-4"
                                        :model.sync="tbem.send_setting"
                                        :name="`condition-option-send-email-${idx}-${index}`"
                                        :id="`condition-option-send-email-${idx}-${index}`"
                                        :value="item.id"
                                        :label="item.label"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="tbem.send_setting == OPTION_SENDING_CONDITIONS[0].id">
                        <!-- 宛先アドレス -->
                        <div class="form-group row">
                            <label class="col-sm-1 text-nowrap" style="min-width: 190px"
                                >{{ $t('managerForm.settingAdvanced.toAddress') }}
                                <span v-if="onHandleCheckFieldRequired(configData[index].configFieldToAddress.typesValidate)" class="text-danger"
                                    >*</span
                                ></label
                            >
                            <div class="col-sm-9">
                                <InputText
                                    :id="`toAddress-${index}`"
                                    :model.sync="tbem.to_address"
                                    :config.sync="configData[index].configFieldToAddress"
                                    @blur="handleValidateField(configData[index].configFieldToAddress, 'more-mail')"
                                />
                                <span class="inputSupportInfo">{{ $t('managerForm.settingAdvanced.noteBlockConditionMail') }}</span>
                            </div>
                        </div>
                        <!-- BCCアドレス -->
                        <div class="form-group row">
                            <label class="col-sm-1 text-nowrap" style="min-width: 190px"
                                >{{ $t('managerForm.settingAdvanced.bcc') }}
                                <span v-if="onHandleCheckFieldRequired(configData[index].configFieldBccAddress.typesValidate)" class="text-danger"
                                    >*</span
                                ></label
                            >
                            <div class="col-sm-9">
                                <InputText
                                    :id="`bccAddress-${index}`"
                                    :model.sync="tbem.bcc_address"
                                    :config.sync="configData[index].configFieldBccAddress"
                                    @blur="handleValidateField(configData[index].configFieldBccAddress, 'more-mail')"
                                />
                                <span class="inputSupportInfo">{{ $t('managerForm.settingAdvanced.noteBlockConditionMail') }}</span>
                            </div>
                        </div>
                        <!-- 件名 -->
                        <div class="form-group row">
                            <label class="col-sm-1 text-nowrap" style="min-width: 190px"
                                >{{ $t('managerForm.settingAdvanced.subject') }}
                                <span v-if="onHandleCheckFieldRequired(configData[index].configFieldSubject.typesValidate)" class="text-danger"
                                    >*</span
                                ></label
                            >
                            <div class="col-sm-9">
                                <InputText
                                    :id="`Subject-${index}`"
                                    :model.sync="tbem.subject"
                                    :config.sync="configData[index].configFieldSubject"
                                    @blur="handleValidateField(configData[index].configFieldSubject)"
                                />
                            </div>
                        </div>
                        <!-- 本文 -->
                        <div class="form-group row">
                            <label class="col-sm-1 text-nowrap" style="min-width: 190px"
                                >{{ $t('managerForm.settingAdvanced.mainText') }}
                                <span v-if="onHandleCheckFieldRequired(configData[index].configFieldMainText.typesValidate)" class="text-danger"
                                    >*</span
                                ></label
                            >
                            <div class="col-sm-9">
                                <div class="position-relative">
                                    <div class="pl-0 col-sm-4">
                                        <Multiselect
                                            :id="`blockChoiceSendingMail-${index}`"
                                            :value.sync="blockChoiceSendingMail"
                                            :options="listOriginBlock"
                                            :config="configData[index].configFieldSelectChoiceSendingMail"
                                            @select="onHandleSetBlockChoiceSendingMail(index)"
                                        />
                                    </div>
                                    <div class="w-100">
                                        <Editor
                                            ref="TextareaComponent"
                                            :id="`mainText-${index}-${activeBlockTab}-${tbem.send_setting}`"
                                            :key="`mainText-${index}-${activeBlockTab}-${tbem.send_setting}`"
                                            :model.sync="tbem.main_text"
                                            :configInit="editorConfigWithoutVideo"
                                            :configError.sync="configData[index].configFieldMainText"
                                            @blur="handleValidateField(configData[index].configFieldMainText)"
                                        />
                                        <div v-if="configData[index].configFieldMainText.error" class="d-block invalid-feedback mt-1">
                                            <span>
                                                {{ configData[index].configFieldMainText.errorCustomMess }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-card-text>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import { OPTION_SENDING_CONDITIONS, selectDefaultSendmail } from '../../constants';
import { InputRadio, InputText } from '@/components/Input';
import { onHandleCheckFieldRequired } from '@/utils/handlers';
import { validateField, validateAllField } from '@/utils/validate';
import { onHandleMoreMail, onHandleEditorConfigWithoutVideo } from '../../handlers';

import Multiselect from '@/components/Multiselect/main.vue';
import Editor from '@/components/Editor/main.vue';

export default {
    name: 'BlockSendingAdmin',
    components: {
        InputRadio,
        InputText,
        Editor,
        Multiselect
    },
    props: {
        opTabpanel: {
            type: Array,
            required: true,
            default: () => []
        },

        configData: {
            type: Array,
            required: true,
            default: () => []
        },

        listOriginBlock: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    data() {
        return {
            blockTab: this.opTabpanel,
            configBlocks: this.configData,
            OPTION_SENDING_CONDITIONS,
            blockChoiceSendingMail: selectDefaultSendmail(),
            activeBlockTab: 0,
            editorConfigWithoutVideo: onHandleEditorConfigWithoutVideo()
        };
    },
    methods: {
        onHandleCheckFieldRequired,

        handleValidateField(configField, action = null) {
            validateField(configField);
            switch (action) {
                case 'more-mail':
                    onHandleMoreMail(configField, 'one');
                    break;
            }
        },

        handleValidateAllField() {
            let checkAll = true;
            for (let i = 0; i < this.blockTab.length; i++) {
                if (this.blockTab[i].send_setting === OPTION_SENDING_CONDITIONS[0].id) {
                    if (!validateAllField(this.configBlocks[i])) {
                        checkAll = false;
                        break;
                    }
                }
            }
            return checkAll;
        },

        onHandleValidateMail() {
            let checkMailBlock = true;
            for (let i = 0; i < this.configBlocks.length; i++) {
                if (
                    !onHandleMoreMail(
                        {
                            configFieldToAddress: this.configBlocks[i].configFieldToAddress,
                            configFieldBccAddress: this.configBlocks[i].configFieldBccAddress
                        },
                        'all'
                    )
                ) {
                    checkMailBlock = false;
                }
                break;
            }
            return checkMailBlock;
        },

        onHandleSetBlockChoiceSendingMail(idx) {
            const editor = this.$refs.TextareaComponent[idx].editorInstance;
            if (!editor) return;
            editor.insertContent(`<<${this.blockChoiceSendingMail.label}>>`);
            setTimeout(() => {
                this.blockChoiceSendingMail = selectDefaultSendmail();
            });
        },

        onSetActiveBlockTab() {
            this.activeBlockTab = 0;
        }
    },
    watch: {
        opTabpanel: {
            handler(val) {
                this.blockTab = val;
            },
            deep: true
        },

        configData: {
            handler(val) {
                this.configBlocks = val;
            },
            deep: true
        },

        blockTab: {
            handler(val) {
                this.$emit('update:opTabpanel', val);
            },
            deep: true
        }
    }
};
</script>

<style lang="scss" scoped></style>

<style lang="scss">
.nav-block-custom {
    li {
        border: 1px solid #339162 !important;
        min-width: 75px;
        margin: 0 0.25rem 0.25rem 0;
    }
}

.acitve-block-custom-form {
    background: #339162 !important;
    color: #ffffff !important;
    border: 1px solid #339162 !important;
    border-radius: unset !important;
}
</style>
